if (!customElements.get('wlsn-banner-notification')) {
    class WLSNBannerNotification extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                close: 'js-wlsn-banner-notification-close',
                hidden: 'is-hidden',
                visible: 'is-visible',
                heroButtonContainer: 'wlsn-atom-x-heroblock__button-content-container'
            };

            this.elements = {
                close: this.querySelector(`.${this.classes.close}`),
                heroButtonContainer: document.querySelector(
                    `.${this.classes.heroButtonContainer}`
                )
            };

            this.handleClose = this.handleClose.bind(this);
            this.updatePosition = this.updatePosition.bind(this);
        }

        connectedCallback() {
            this.elements.close?.addEventListener('click', this.handleClose);
        
            this.updatePosition();
        
            requestAnimationFrame(() => {
                this.classList.add('is-visible');
            });
        
            if (this.elements.heroButtonContainer) {
                this.resizeObserver = new ResizeObserver(this.updatePosition);
                this.resizeObserver.observe(this.elements.heroButtonContainer);
            }
        }

        disconnectedCallback() {
            this.elements.close?.removeEventListener('click', this.handleClose);
            window.removeEventListener('resize', this.updatePosition);
        }

        handleClose() {
            this.classList.add(this.classes.hidden);
            this.classList.remove(this.classes.visible);
        }

        updatePosition() {
            if (window.innerWidth > 767) {
                this.style.removeProperty('bottom');
                return;
            }

            if (!this.elements.heroButtonContainer) {
                return;
            }

            const height = this.elements.heroButtonContainer.offsetHeight;

            this.style.bottom = `${height + 20}px`;
        }
    }

    customElements.define('wlsn-banner-notification', WLSNBannerNotification);
}